// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  margin: 45px 0 30px 0;
  width: 100%;
  float: left;

  display: grid;
  grid-template-columns: auto 358px auto;
  border-top: solid 1px #e5e5e5;

  @media (max-width: 1100px) {
    grid-template-columns: 33% 34% 33%;
  }
  @media (max-width: 700px) {
    grid-template-columns: 50% 50%;
  }
`;

class SetHighlightBlocks extends Component {
  render() {
    return (
      <Wrapper>
        {this.props.set.map(item => <HighlightBlock key={item.id} content={item} />)}
      </Wrapper>
    );
  }
}

export default SetHighlightBlocks;

const Item = styled.div`
  width: 356px;
  border-bottom: solid 1px #e5e5e5;

  :nth-child(3n + 1) {
    padding-left: calc(50vw - 535px);
  }
  :nth-child(3n + 2) {
    border: solid 1px #e5e5e5;
    border-top: 0;
  }
  :nth-child(3n) {
    padding-right: calc(50vw - 535px);
  }

  @media (max-width: 1100px) {
    width: 100%;
    :nth-child(3n + 1) {
      padding-left: 0;
    }
    :nth-child(3n + 2) {
      width: calc(100% - 2px);
    }
    :nth-child(3n) {
      padding-right: 0;
    }
  }
  @media (max-width: 700px) {
    :nth-child(2n + 1) {
      padding: 0 6px 0 23px;
      border-right: 0;
      border-left: 0;
      width: calc(100% - 29px);
    }
    :nth-child(2n) {
      padding: 0 23px 0 6px;
      border-right: 0;
      border-left: solid 1px #e5e5e5;
      width: calc(100% - 30px);
    }
  }
`;
const Image = styled.div`
  height: 0;
  margin: 41px 50px 25px 50px;
  width: 256px;
  padding-bottom: 58%;

  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  @media (max-width: 1100px) {
    margin: 41px 35px 25px 35px;
    width: calc(100% - 70px);
  }
  @media (max-width: 700px) {
    margin: 14px 8px;
    width: calc(100% - 16px);
  }
`;
const Title = styled.div`
  margin: 0 25px 5px 25px;
  width: 306px;

  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.53;
  letter-spacing: 0.9px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    width: calc(100% - 50px);

    font-size: ${scale(1100, 700, 15, 11, "vw")};
    line-height: ${scale(1100, 700, 15 * 1.53, 11 * 1.91, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0 0 5px 0;

    font-size: 11px;
    line-height: 1.91;
    letter-spacing: 0.7px;
  }
`;
const Body = styled.div`
  margin: 0 25px 25px 25px;
  width: 306px;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    width: calc(100% - 50px);

    font-size: ${scale(1100, 700, 14, 10, "vw")};
    letter-spacing: ${scale(1100, 700, 1, 0.7, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0 0 14px 0;

    font-size: 10px;
    line-height: 1.6;
    letter-spacing: 0.7px;
  }
`;

class HighlightBlock extends ArticleAbstract {
  render() {
    return (
      <Item>
        <Image style={this.image()} />
        <Title>{this.title()}</Title>
        <Body>
          <FlatBody>{this.body()}</FlatBody>
        </Body>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetHighlightBlocks.js